/* eslint-disable complexity */
import React, { useEffect, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import {
    LEAD_FORM,
    NUMBER,
    STEP_NAMES
} from "../../../constants/app-constants";
import CarBrands from "../car-brands";
import { FUNNEL_CONFIG } from "../../../utils/funnel/steps.desktop";
import { sendCustomGaEvents } from "../../../tracking";
import styles from "./styles.css";
import CarRegistrationNumber from "../car-registration-number";
import { clickedBrandIcon } from "./tracking";
import reorderBrandList from "../../../utils/helpers/reorder-brand-list";
import { Label } from "@cars24/turbo-web/lib/label";
import LazyImage from "../../shared/lazy-image";
import { BodyText } from "@cars24/turbo-web/lib/body-text";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";

const LeadRegNo = ({
    all,
    isSSR,
    popular,
    leadData,
    setDataConnect,
    setStepConnect,
    fetchDataConnect,
    activateLastStepConnect,
    activateFirstStepConnect,
    resetRegistrationDataConnect,
    ctaText,
    isBrandsVisible = true,
    isScrapBenefitsVisible = false,
    scrapCars,
    isDlsCompliant = false,
    isLuxuryPage,
    luxury
}) => {
    const { tokens } = useTokens();
    const { cmsData = {} } = scrapCars || {};
    const {heroImageDescription = {}} = cmsData || {};
    const { tabData = [], title: scrapTitle = "" } = heroImageDescription || {};
    const visiblePopularBrands = isLuxuryPage ? NUMBER.TWELVE : NUMBER.EIGHT;
    const brandList = useMemo(
        () =>
            reorderBrandList({
                popular: isLuxuryPage ? luxury : popular,
                visiblePopularBrands
            }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [luxury, visiblePopularBrands, popular]);

    const {
        brand: { id }
    } = leadData;
    const registrationInputRef = useRef(null);
    const formConfig = FUNNEL_CONFIG[LEAD_FORM.DEFAULT_REVAMP];
    useEffect(() => {
        if (!isSSR) {
            fetchDataConnect();
        }
    }, [fetchDataConnect, isSSR]);

    const onSetData = (data) => {
        setDataConnect(data, formConfig);
        sendCustomGaEvents({
            ...clickedBrandIcon,
            eventLabel: data?.data?.displayText
        });
    };

    const nextStep = () => {
        resetRegistrationDataConnect();
        setStepConnect({ currentStep: STEP_NAMES.Year, tabs: formConfig.tabs });
        activateFirstStepConnect(false);
        activateLastStepConnect(false);
    };

    const onClickMore = () => {
        setStepConnect({ currentStep: STEP_NAMES.Brand, tabs: formConfig.tabs });
        activateFirstStepConnect(false);
        activateLastStepConnect(false);
    };
    return (
        <div styleName={"styles.leadForm"}>
            <label styleName={"styles.heading"}>Enter your car number</label>
            <CarRegistrationNumber registrationInputRef={registrationInputRef} ctaText={ctaText} isDlsCompliant={isLuxuryPage || isDlsCompliant} />
            {
                isBrandsVisible && <React.Fragment>
                    <p styleName={"styles.or"}>
                        <span styleName={`styles.textWrapper ${isLuxuryPage ? "styles.orSelectText" : "styles.orText"}`}>
                            {isLuxuryPage ? "OR SELECT MANUALLY" : "Or"}
                        </span>
                    </p>

                    {!isLuxuryPage && <div styleName={"styles.label"}><Label level={NUMBER.FOUR}>Start with your car brand</Label></div>}
                    <div styleName={"styles.carBrand"}>
                        <CarBrands
                            popularItems={brandList}
                            allItems={all}
                            size={isLuxuryPage ? NUMBER.TWELVE : NUMBER.EIGHT}
                            stepName={STEP_NAMES.Brand}
                            setData={onSetData}
                            expandable={false}
                            nextStep={nextStep}
                            selected={id}
                            isRevamped={true}
                            onMoreClickCallback={onClickMore}
                            isLazyLoad={false}
                            isLuxuryPage
                        />
                    </div>
                </React.Fragment>
            }

            {isScrapBenefitsVisible && tabData.length > 0 &&
                <>
                    <div styleName={"styles.borders"} />
                    <Label level={NUMBER.THREE} fontWeight="medium" color={tokens.icon_default_icon_primary}>{scrapTitle}</Label>
                    <ul styleName={"styles.benefitsList"}>
                        {tabData.map(({ image, title, highlightText, subTitle }, index) => {
                            return (<li key={`${title}-${index}`}>
                                <LazyImage src={image.url} alt={image.alternativeText} height="36px" width="36px" />
                                <div styleName={"styles.highlightTextWrapper"}>
                                    <BodyText level={NUMBER.TWO} color={tokens.icon_default_icon_secondary}>{title}</BodyText>
                                    <div styleName={"styles.highlightText"}>
                                        <BodyText level={NUMBER.TWO} isBold color={tokens.icon_default_icon_secondary}>{highlightText}</BodyText>
                                        {subTitle && <BodyText level={NUMBER.TWO} color={tokens.icon_default_icon_secondary}>{subTitle}</BodyText>}
                                    </div>
                                </div>
                            </li>);
                        }
                        )}
                    </ul>
                </>
            }
        </div>
    );
};

LeadRegNo.propTypes = {
    all: PropTypes.bool,
    isSSR: PropTypes.bool,
    popular: PropTypes.array,
    leadData: PropTypes.object,
    setStepConnect: PropTypes.func,
    setDataConnect: PropTypes.func,
    fetchDataConnect: PropTypes.func,
    activateLastStepConnect: PropTypes.func,
    activateFirstStepConnect: PropTypes.func,
    resetRegistrationDataConnect: PropTypes.func,
    ctaText: PropTypes.string,
    isBrandsVisible: PropTypes.bool,
    isScrapBenefitsVisible: PropTypes.bool,
    isLuxuryPage: PropTypes.bool,
    luxury: PropTypes.array,
    scrapCars: PropTypes.object,
    isDlsCompliant: PropTypes.bool
};

export default LeadRegNo;
